import { render, staticRenderFns } from "./BannersPatientPricingAvailable.vue?vue&type=template&id=3812adc6&scoped=true"
import script from "./BannersPatientPricingAvailable.vue?vue&type=script&lang=js"
export * from "./BannersPatientPricingAvailable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3812adc6",
  null
  
)

export default component.exports